import { render, staticRenderFns } from "./AdvisoryPackageSteps.vue?vue&type=template&id=dddbdb98&scoped=true"
import script from "./AdvisoryPackageSteps.vue?vue&type=script&lang=js"
export * from "./AdvisoryPackageSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddbdb98",
  null
  
)

export default component.exports